import React, { useEffect, useState } from "react";
import MakeTransaction from "./MakeTransaction";
import { getTransactionList, getTransactionListByProjectId } from "../../services/transaction.service";
import { getTransactionReportByUserId } from "../../services/report.service";
import { getProject } from "../../services/Project.service";
import AddIcon from "../../assets/images/add_icon.svg";
import toast from "react-hot-toast";
import PaginatedTable from "../common/PaginatedTable";
import EditIcon from "../../assets/images/edit_icon.svg";
import ViewIcon from "../../assets/images/view_icon.svg";
import DeleteIcon from "../../assets/images/delete_icon.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";


const DetailsTransactions = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showTable, setShowTable] = useState(true);

  //Paginated Table Variables
  let [totalCount, setTotalCount] = useState(0);
  let [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState(10);
  let [searchKey, setSearchKey] = useState("");
  let [isLoading, setIsLoading] = useState(true);
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);
  const [statusFilter, setStatusFilter] = useState("");
  const [ProjectList, setProjectList] = useState([]);

  const handleShowCreate = () => {
    setShowCreate(true);
    setShowTable(false);
  };

  const back = (cond = true) => {
    cond && transactionList();
    setShowCreate(false);
    setShowTable(true);
  };

  useEffect(() => {
    transactionList();
    // getProjectList();
  }, [currentPage, itemsPerPage, searchKey, setSearchKey, statusFilter]);
  // const getProjectList = async () => {
  //   try {
  //     const res = await getProject();


  //     if (res?.status === 200) {

  //       if (res?.data) {
  //         setProjectList(res.data);
  //       }
  //     } else {
  //       toast.error(res?.message || res?.data?.message);
  //     }
  //   } catch (error) {
  //     if (error?.message) {
  //       const msg = error?.message?.split(":")?.[1]?.trim();
  //       // alert(msg);
  //       console.error(msg);
  //     }
  //     console.log(error.message);
  //   }
  // };
  const [column, setColumn] = useState([
    // {
    //   heading: () => "S.No",
    //   cell: (row, i) => {
    //     return i;
    //   },
    //   hidden: false,
    //   width: "20",
    //   id: 1,
    // },
    {
      heading: () => "Action",
      cell: (row) => (
        <>
          <div>
            <img className="CyanSky_filter" onClick={() => navigate(`/admin/edit-transaction/${row?.id}`)} src={ViewIcon} alt="View" />
            <img className="CyanSky_filter" onClick={() => navigate(`/admin/edit-transaction/${row?.id}`)} src={EditIcon} alt="Edit" />
            <img className="CyanSky_filter" src={DeleteIcon} alt="Delete" />
          </div>
        </>
      ),

      hidden: false,
      // width: "120",
      // align: "center",
      id: 1,
    },
    {
      heading: () => "Name",
      cell: (row) => (row["name"] ? row["name"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 2,
    },
    {
      heading: () => "Amount",
      cell: (row) => (row["amount"] ? row["amount"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 3,
    },

    {
      heading: () => "Given by ",
      cell: (row) => (row["userID"] ? row["userID"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 4,
    },
    // {
    //   heading: () => "descripton",
    //   cell: (row) => (row["descripton"] ? row["descripton"] : "-"),
    //   hidden: false,
    //   width: "120",
    //   align: "left",
    //   id: 4,
    // },
    {
      heading: () => "Tansaction Mode",
      cell: (row) => (row["tansactionMode"] ? row["tansactionMode"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 5,
    },

    {
      heading: () => "Flow",
      cell: (row) => (row["flow"] ? row["flow"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 6
    },

    {
      heading: () => "Transaction Status",
      cell: (row) => (row["transactionStatus"] ? "Active" : "Inactive"),
      hidden: false,
      width: "120",
      align: "left",
      id: 7
    },

    // {
    //   heading: () => "Action",
    //   cell: (row) => (
    //     <span  className={row?.active_flag ? "fontWeight600 UFOGreen_text" : "fontWeight600 errorClr_text"}>
    //       {row["active_flag"] ? "Active" : "Inactive"}
    //     </span>
    //   ),
    //   hidden: false,
    //   width: "120",
    //   align: "left",
    //   id: 5,
    // },
  ]);

  const transactionList = async () => {
    try {
      const requestBody = {
        reportid: params.reportid,
        id: params.id,
      };
      let res = {};
      // if(statusFilter !=''){
      res = await getTransactionReportByUserId(requestBody.reportid, requestBody.id);
      // }
      // }else{
      //   res = await getTransactionList(requestBody);
      // }

      if (res?.status === 200) {
        setList(res.data);
        setTotalCount(res.data.length);
      } else {
        toast.error(res?.message || res?.data?.message);
      }

    } catch (error) {
      if (error?.message) {
        const msg = error?.message?.split(":")?.[1]?.trim();
        console.error(msg);
        // alert(msg);
      }
      console.log(error.message);
    }
  };

  var item = list.length > 0 ? list[0] : { displayName: "--" };
  var displayName = item.displayName ? item.displayName : "-";
  // var displayName = item != null ? item.debit.length > 0 ? item.debit[0].name : null : null;
  // if (displayName == null && item && item.credit!=null ) {
  //   displayName = item.credit.length > 0 ? item.credit[0].name : "-";
  // }
  // else
  // {
  //   displayName= displayName?displayName:"--"
  // }



  return (
    <div>
      {showTable && (
        <div>
          <div className="mb_24 displayFlex alignItem_center justifyContent_spacebetween">
            <div>
              <h5 className="fontSize20 fontWeight600 blackClr_text">
                {" "}
                Details of {params.reportid}  {displayName}
              </h5>
            </div>
          </div>

          {isLoading ? (
            <div className="row mb_34">
              <h4>Report by receiver</h4>
              {list.map((count) => (
                <div className="col-lg-3 mob_mb24">
                  <div class="card" >
                    <div class="card-header">
                      Project  : {count.name} (V :{count.projectValue}- E:{count.expenseValue}%)
                    </div>
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item"> <div class="card-header">
                        Debit
                      </div></li>
                      <li class="list-group-item">{count.debit.map((debit) => (
                        <p>
                          <p className="SteelWoolClr_text fontSize16 fontWeight500">To : {debit.name}</p>
                          <p className="SteelWoolClr_text fontSize16 fontWeight500">Amount : {debit.amount}</p>
                          <p className="SteelWoolClr_text fontSize16 fontWeight500">Date   : {debit.transactionDate.substring(0, 10)}</p>
                          {debit.location && <p className="SteelWoolClr_text fontSize16 fontWeight500">Location   : {debit.location.name}</p>}
                                {debit.descripton &&  <p
                                className={'SteelWoolClr_text fontSize16 fontWeight500' }
                                style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word', textAlign: 'left' }}
                              >

                              Details :
                              <span style={{ display: 'inline-block', maxWidth: '100%' }}>{String(debit.descripton)}</span>
                            </p>
                            }
                        </p>
                      ))}</li>
                      <li class="list-group-item"> <div class="card-header">
                        Credit
                      </div></li>
                      <li class="list-group-item">
                        {count.credit.map((item) => (
                          <p>
                            <p className="SteelWoolClr_text fontSize16 fontWeight500">From : {item.name}</p>
                            <p className="SteelWoolClr_text fontSize16 fontWeight500">Amount : {item.amount}</p>
                            <p className="SteelWoolClr_text fontSize16 fontWeight500">Date   : {item.transactionDate.substring(0, 10)}</p>
                            {item.location && <p className="SteelWoolClr_text fontSize16 fontWeight500">Location   : {item.location.name}</p>}
                             {item.descripton &&  <p
                                className={'SteelWoolClr_text fontSize16 fontWeight500' }
                                style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word', textAlign: 'left' }}
                              >

                              Details :
                              <span style={{ display: 'inline-block', maxWidth: '100%' }}>{String(item.descripton)}</span>
                            </p>
                            }
                          </p>
                        ))}
                        <hr></hr>
                      </li>
                    </ul>
                  </div>

                </div>
              ))}

            </div>
          ) : (
            <div style={{ textAlign: "center" }}>Loading...</div>
          )}
        </div>
      )}

      {showCreate && <MakeTransaction back={back} statusFilter={statusFilter} />}
    </div>
  );
};

export default DetailsTransactions;
